function formatValue(value) {
  const string = Number(value).toFixed(2);
  const parts = string.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const formattedTotal = `R$ ${parts.join(",")}`;

  return formattedTotal;
}

function formatDate(date) {
  return [
    date.getDate().toString().padStart(2, "0"),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getFullYear().toString().slice(-2),
  ].join("/");
}

function parseCustomDate(dateString) {
  if (!dateString || typeof dateString !== 'string') return null;
  const cleanString = dateString.replace(/\//g, '-').split(' ')[0] + 'T00:00:00';
  const date = new Date(cleanString);
  return isNaN(date.getTime()) ? null : date;
}

function openTrackModal(orderId, invoice) {
  const { carrier, invoiceId, issueDate } = invoice;

  const deliveryTrackModal = document.querySelector("#delivery-track-modal");
  const deliveryTrackClose = document.querySelector("#delivery-track-close");
  const orderStatusUpdateContainer = document.querySelector("#order-status-updates-container");

  if (!deliveryTrackModal || !deliveryTrackClose) return;

  deliveryTrackModal.classList.add("open");
  deliveryTrackClose.addEventListener("click", () => {
    deliveryTrackModal.classList.remove("open");
  });

  orderStatusUpdateContainer.innerHTML = "";
  orderStatusUpdateContainer.classList.add("loading");

  const orderInvoicNumberElement = document.querySelector(
    "#order-invoice-number"
  );
  const orderCreationDateElement = document.querySelector(
    "#order-creation-date"
  );
  const deliveryCompanyElement = document.querySelector(
    "#order-delivery-company"
  );

  if (
    orderInvoicNumberElement &&
    orderCreationDateElement &&
    deliveryCompanyElement
  ) {
    orderInvoicNumberElement.textContent = invoice.invoiceId;
    orderCreationDateElement.textContent = new Intl.DateTimeFormat("pt-BR").format(new Date(issueDate));
    deliveryCompanyElement.textContent = carrier.name;
  }

  showMyAccountSpinner(orderStatusUpdateContainer);

  getInvoiceTracking(orderId, invoiceId)
    .then(res => {
      if (res.message || !Array.isArray(res) || !res.length) {
        const warningElement = document.createElement("h3");
        warningElement.textContent = "Não há atualizações para o pedido";

        orderStatusUpdateContainer.appendChild(warningElement);

        return;
      }

      const titleElement = document.createElement("h3");
      titleElement.textContent = "Atualizações do Pedido";
      orderStatusUpdateContainer.appendChild(titleElement);

      const headingElement = document.createElement("div");
      headingElement.classList.add("updates-heading");
      const headingDateElement = document.createElement("span");
      headingDateElement.classList.add("datetime");
      headingDateElement.textContent = "Data";
      const headingStatusElement = document.createElement("span");
      headingStatusElement.textContent = "Status";

      headingElement.appendChild(headingDateElement);
      headingElement.appendChild(headingStatusElement);

      const orderStatusUpdatesElement = document.createElement("div");
      orderStatusUpdatesElement.classList.add("updates-body");

      const trackingBarContainer = document.getElementById("tracking-bar-container");
      const lastTracking = res[res.length - 1];

      for (const tracking of res) {
        const updateItemElement = document.createElement("div");
        updateItemElement.classList.add("update-item");
        const dateTimeContainer = document.createElement("div");
        dateTimeContainer.classList.add("update-datetime");

        new Date().toString();

        const [date, time] = new Date(tracking.occurrenceDate).toLocaleString().split(", ");

        const dateElement = document.createElement("h4");
        dateElement.textContent = date;
        const timeElement = document.createElement("span");
        timeElement.textContent = time.split(":").slice(0, 2).join(":");

        dateTimeContainer.appendChild(dateElement);
        dateTimeContainer.appendChild(timeElement);
        updateItemElement.appendChild(dateTimeContainer);

        const trackingDescription = tracking.occurrenceDescription;

        const infoElement = document.createElement("div");
        infoElement.classList.add("update-info");
        const descriptionElement = document.createElement("h4");
        descriptionElement.textContent = trackingDescription;

        infoElement.appendChild(descriptionElement);
        updateItemElement.append(infoElement);

        if (tracking.occurrenceCode === "TRACKING|01") {
          const downloadButton = document.createElement("button");
          downloadButton.textContent = "Canhoto";
          downloadButton.classList.add("canhoto-btn-download");
          downloadButton.addEventListener("click", () => downloadCanhoto(downloadButton));
          updateItemElement.appendChild(downloadButton);
        }

        orderStatusUpdatesElement.appendChild(updateItemElement);
      }

      if (lastTracking) {
        renderTrackingBar(trackingBarContainer, lastTracking);
      }

      orderStatusUpdateContainer.append(headingElement);
      orderStatusUpdateContainer.appendChild(orderStatusUpdatesElement);
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      orderStatusUpdateContainer.classList.remove("loading");
      removeMyAccountSpinner(orderStatusUpdateContainer);
    });
}

function renderTrackingBar(container, tracking) {
  const { occurrenceDescription, occurrenceSuccess, occurrenceStep } = tracking;
 
  const TOTAL = 3;
  const leftPct = (occurrenceStep / TOTAL) * 100;
 
  function arrowColor(idx) {
    if (occurrenceSuccess) return idx <= occurrenceStep ? "arrow-purple" : "arrow-gray";
    if (idx < occurrenceStep) return "arrow-purple";
    if (idx === occurrenceStep) return "arrow-pink";
    return "arrow-gray";
  }
 
  const checkIcon = `<svg width="21" height="18" viewBox="0 0 14 11" fill="none">
    <path d="M1 5.5L5 9.5L13 1.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
 
  const xIcon = `<svg width="18" height="18" viewBox="0 0 12 12" fill="none">
    <path d="M1 1L11 11M11 1L1 11" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
  </svg>`;
 
  container.innerHTML = `
    <div class="tracking-progress">
      <div class="tracking-arrows">
        ${[1, 2, 3].map((i) => `<div class="tracking-arrow ${arrowColor(i)}"></div>`).join("")}
        <div class="tracking-badge ${occurrenceSuccess ? "badge-purple" : "badge-red"}" style="left: ${leftPct}%;">
          ${occurrenceSuccess ? checkIcon : xIcon}
        </div>
        <div class="tracking-label" style="left: ${leftPct}%;">${occurrenceDescription}</div>
      </div>
    </div>
  `;
}

async function downloadCanhoto(button) {
  try {
    button.disabled = true;
    button.textContent = "Baixando...";

    const orgDocument = getCnpjR();
    const token = await login();
    const invoiceNumber = document.getElementById("order-invoice-number").textContent.trim();

    const params = new URLSearchParams({ orgDocument, invoiceNumber });

    const response = await fetch(`https://ws.efurukawa.com/prd/tracking/invoice/stub?${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Erro ao baixar canhoto: ${response.status}`);
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${invoiceNumber}.png`;
    link.click();
    URL.revokeObjectURL(url);

  } catch (err) {
    console.error("Erro ao baixar canhoto:", err);
    button.classList.add("download-btn--error");
    button.textContent = "Canhoto não encontrado";

    setTimeout(() => {
      button.classList.remove("download-btn--error");
      button.textContent = "Baixar Canhoto";
    }, 3000);
  } finally {
    button.disabled = false;
  }
}

let currentPage = 1;
let totalPages = 1;
const itemsPerPage = 10;

// Função principal para buscar os pedidos
async function getOrderData(page = 1, filterBy = '', filter = '', sortDirection = 'asc') {
  currentPage = page;
  
  try {
    currentPage = page;
    const domain = baseMsUrl();
    const token = await login();
    const cnpjR = getCnpjR();

    if (!cnpjR) {
      console.error('[getOrderData] Erro: Não foi possível obter os dados da empresa');
      throw "Não foi possível obter os dados da empresa";
    }

    const params = new URLSearchParams();
    params.append("customerId", customerId);
    params.append("limit", itemsPerPage);
    params.append("offset", (page - 1) * itemsPerPage);
    if (filterBy) params.append("filterBy", filterBy);
    if (filter) params.append("filter", filter);
    if (sortDirection) { 
      params.append("property", 'creationDate');
      params.append("sort", sortDirection);
    }
    params.append("height", 100);
    params.append("width", 100);

    const url = `${domain}/shopify-order-connector/v1/shopify-order-connector/orders?${params}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  
    if (!response.ok) {
      const errorDetails = await response.text();
      console.error(`[getOrderData] Erro na resposta: Status ${response.status}, Detalhes: ${errorDetails}`);
      throw response.status;
    }

    const data = await response.json();

    totalPages = Math.ceil(data.totalResults / itemsPerPage);

    await renderOrdersData(data.items);
    
    renderPagination();
    
    return data;
  } catch (err) {
    console.error('[getOrderData] Erro capturado:', err);
    throw new Error(`Erro ao buscar pedidos: ${err}`);
  }
}

async function getInvoiceTracking(orderId, invoiceNumber) {
  const params = new URLSearchParams();

  const domain = baseMsUrl();
  const token = await login();

  params.append("orderId", orderId);
  params.append("invoiceNumber", invoiceNumber);
  params.append("customerId", customerId);

  const url = `${domain}/shopify-order-connector/v1/shopify-order-connector/invoice-orders/tracking?${params.toString()}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
  const data = await response.json();

  if (!response.ok) {
    console.log(`[getInvoiceTracking] Não foi possível recuperar as informações de tracking: ${JSON.stringify(data)}`);
    return;
  }

  return data;
}

function renderPagination() {
  const paginationContainer = document.getElementById('pagination-container');
  
  if (!paginationContainer) {
    console.error('[renderPagination] Container de paginação não encontrado');
    return;
  }
  
  paginationContainer.innerHTML = '';


  const prevButton = document.createElement('button');
  prevButton.textContent = 'Anterior';
  prevButton.disabled = currentPage === 1;
  
  prevButton.addEventListener('click', () => {

    if (currentPage > 1) {
      const newPage = currentPage - 1;
      getOrderData(newPage);
    }
  });
  paginationContainer.appendChild(prevButton);

  const maxVisibleButtons = 5;
  let startPage, endPage;

  if (totalPages <= maxVisibleButtons) {
    startPage = 1;
    endPage = totalPages;
  } else {
    const maxButtonsBeforeCurrent = Math.floor(maxVisibleButtons / 2);
    const maxButtonsAfterCurrent = Math.ceil(maxVisibleButtons / 2) - 1;
    
    if (currentPage <= maxButtonsBeforeCurrent) {
      startPage = 1;
      endPage = maxVisibleButtons;
    } else if (currentPage + maxButtonsAfterCurrent >= totalPages) {
      startPage = totalPages - maxVisibleButtons + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxButtonsBeforeCurrent;
      endPage = currentPage + maxButtonsAfterCurrent;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    const pageButton = document.createElement('button');
    pageButton.textContent = i;
    
    if (i === currentPage) {
      pageButton.classList.add('active');
    }
    
    pageButton.addEventListener('click', () => {
      getOrderData(i); 
    });
    
    paginationContainer.appendChild(pageButton);
  }

  const nextButton = document.createElement('button');
  nextButton.textContent = 'Próximo';
  nextButton.disabled = currentPage === totalPages;
  
  nextButton.addEventListener('click', () => {

    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      getOrderData(newPage);
    }
  });
  paginationContainer.appendChild(nextButton);

}

async function initOrdersPage() {
  currentPage = 1;
  await getOrderData(1);

  if (!customerId) {
    console.error('[initOrdersPage] Erro: customerId não disponível');
    return;
  }

  const queryForm = document.getElementById("order-query-id");

  queryForm.addEventListener('submit', (event) => {
    event.preventDefault();

    searchOrders();
  });

  //await getOrderData(1);
}

document.addEventListener('DOMContentLoaded', function() {
  initOrdersPage();
});

let sortAscending = true;

async function renderOrdersData(orderRecords) {
  
  const blocksContainer = document.getElementById("tab-orders");
  if (!blocksContainer) {
    console.error("[renderOrdersData] ❌ #tab-orders não encontrado no DOM.");
    return;
  }

  if (orderRecords.length === 0) {
    blocksContainer.innerHTML = "";
    const orderBlock = document.createElement("div");
    orderBlock.classList.add("dados");
    orderBlock.textContent = "No momento, você não possui pedidos.";
    blocksContainer.appendChild(orderBlock);
    return;
  }

  blocksContainer.innerHTML = "";

  const header = document.createElement("div");
  header.className = "order-header";
  header.innerHTML = `
    <p class="balance-value order-number">Número do Pedido</p>
    <p class="balance-value po-number">Nº Ordem de Compra</p>
    <div class="creation-date sort-wrapper">
      <p class="balance-value creation-date">Data de Criação</p>
      <button class="sort-button" onClick="sortDirection()"></button>
    </div>
    <p class="balance-value payment-condition">Condição de pagamento</p>
    <p class="balance-value total-value">Valor</p>    
    <p class="balance-value status">Status</p>    
    `;
  
  blocksContainer.appendChild(header);
  
  const arrowDown = document.getElementById("arrow-up-down").cloneNode(true);
  arrowDown.style.display = "inline";
  const sortButton = document.querySelector(".sort-button");
  if (sortAscending) sortButton.classList.add("asc");
  sortButton.appendChild(arrowDown);

  orderRecords.forEach((record) => {
    try {
      const {
        total,
        payments,
        id,
        poNumber,
        internalCommerceOrderId,
        creationDate,
        status,
      } = record;

      const block = document.createElement("div");
      block.className = "order-block";
      block.setAttribute("data-page", "/pages/detalhes-do-pedido");
      block.setAttribute("record", JSON.stringify(record));

      const orderInfoElement = document.createElement("div");
      orderInfoElement.classList.add("order-info");

      const orderMainElement = document.createElement("div");
      orderMainElement.classList.add("main");

      const orderIdElement = document.createElement("p");
      orderIdElement.textContent = id;
      orderIdElement.className = "balance-value bold order-id";

      const creationDateElement = document.createElement("p");
      creationDateElement.classList.add("creation-date");
      const datedDate = new Date(creationDate);
      const [day, month, year] = [
        datedDate.getUTCDate().toString().padStart(2, "0"),
        (datedDate.getUTCMonth() + 1).toString().padStart(2, "0"),
        datedDate.getUTCFullYear().toString().slice(-2).padStart(2, "0")
      ];
      const formattedDate = `${day}/${month}/${year}`;
      creationDateElement.textContent = formattedDate;

      const poNumberElement = document.createElement("p");
      poNumberElement.textContent = poNumber;
      poNumberElement.className = "po-number";

      const paymentElement = document.createElement("p");
      const payment = payments[0].paymentMethodId;
      let formattedPayment = payment;

      paymentElement.textContent = formattedPayment;
      paymentElement.className = "order-payment";

      const totalString = Number(total).toFixed(2);
      const totalElement = document.createElement("p");
      const parts = totalString.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      const formattedTotal = `R$ ${parts.join(",")}`;
      totalElement.textContent = formattedTotal;
      totalElement.className = "balance-value bold order-total";

      const statusElement = document.createElement("p");

      let formattedStatus = "";
      switch (status) {
        case "booked":
          formattedStatus = "Confirmado";
          break;
        case "closed":
          formattedStatus = "Faturado";
          break;
        case "cancelled":
          formattedStatus = "Cancelado";
          break;
        default:
          formattedStatus = "Em análise";
      }

      statusElement.textContent = formattedStatus;
      statusElement.className = `status ${status}`;

      const linkElement = document.createElement("a");
      const svgIcon = document.getElementById("arrow-right").cloneNode(true);
      svgIcon.style.display = "inline";
      linkElement.appendChild(svgIcon);
      linkElement.className = "order-link";

      orderMainElement.appendChild(orderIdElement);
      orderMainElement.appendChild(poNumberElement);
      orderMainElement.appendChild(creationDateElement);
      orderMainElement.appendChild(paymentElement);
      orderMainElement.appendChild(totalElement);
      orderMainElement.appendChild(statusElement);

      orderInfoElement.appendChild(orderMainElement);

      block.appendChild(orderInfoElement);
      block.appendChild(linkElement);

      blocksContainer.appendChild(block);

      block.addEventListener("click", async (event) => {
        event.preventDefault();

        const pageUrl = block.getAttribute("data-page");
        const pageContent = document.getElementById("page-content");

        setActiveLink(block);

        if (pageContent) {
          try {
            const response = await fetch(pageUrl);
            if (!response.ok) throw new Error("Erro ao carregar a página.");

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const content = doc.querySelector("#page-account");

            pageContent.innerHTML = content
              ? content.innerHTML
              : "<p>Conteúdo não encontrado.</p>";

            await loadOrderDetails(record);

            document.querySelectorAll(".sidebar .menu a").forEach((link) => {
              if (link.getAttribute("data-page") === "/pages/pedidos") {
                link.classList.add("active");
              }
            });
          } catch (error) {
            console.error(error);
            pageContent.innerHTML = "<p>Erro ao carregar o conteúdo.</p>";
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  });
}

function renderOrderDetailData(orderData) {
  if (orderData) {
    const {
      id: orderId,
      customer,
      lastUpdate,
      shippingAddress,
      billingAddress,
      ovNumber,
      poNumber,
      invoices,
      coupons,
      payments,
      orders,
      status,
      total: orderTotal,
    } = orderData;

    const order = orders[0];
    const mainInvoice = invoices[0];

    if (order) {
      const { financialSummary, items, historyOrderStatus } = order;

      //Order status
      if (historyOrderStatus) {
        for (const orderStatus of historyOrderStatus) {
          if (status === "closed") {
            document
              .querySelector("#step-heading-booked")
              .classList.add("active");
          } else if (status === "canceled") {
            document
              .querySelector("#step-heading-processing")
              .classList.remove("active");
          }

          const stepHeadingElements = document.querySelectorAll(
            `#step-heading-${status}`
          );
          stepHeadingElements.forEach((e) => e.classList.add("active"));

          const stepDateElements = document.querySelectorAll(
            `#step-${status}-date`
          );
          
          const rawDate = status === "closed" ? mainInvoice?.issueDate : lastUpdate;

          let formattedDate = "";

          if (rawDate) {
            const dateObj = new Date(rawDate);
            if (!isNaN(dateObj.getTime())) {
              formattedDate = new Intl.DateTimeFormat('pt-BR', {
                timeZone: 'UTC'
              }).format(dateObj);
            }
          }
          stepDateElements.forEach((e) => (e.textContent = formattedDate));
        }
      }

      //Itens
      const itemListField = document.querySelector("#order-items-list");
      if (itemListField) {
        if (items) {
          for (const item of items) {
            const { image, skuId, quantity, displayName, amount } = item;

            const itemField = document.createElement("li");
            const imageContainerField = document.createElement("div");
            const imageField = document.createElement("img");
            const infoField = document.createElement("div");

            imageField.src =
              image ||
              "https://shop.lightera.com/cdn/shop/files/produto_sem_imagem_500px.jpg";
            imageField.alt = displayName;
            imageContainerField.classList.add("order-item-image-container");
            imageContainerField.appendChild(imageField);

            infoField.classList.add("order-item-info");

            const skuIdField = document.createElement("div");
            skuIdField.textContent = `Código: ${skuId}`;

            const wrapper = document.createElement("div");
            wrapper.classList.add("tooltip-wrapper");

            const titleField = document.createElement("div");

            const tooltipText = document.createElement("div");
            tooltipText.classList.add("tooltip-text");
            tooltipText.textContent = displayName;

            wrapper.appendChild(titleField);
            wrapper.appendChild(tooltipText);

            const quantityField = document.createElement("div");
            const amountField = document.createElement("div");

            if (quantity > 0) {
              titleField.classList.add("order-item-title");
              titleField.textContent = displayName;

              quantityField.classList.add("order-item-quantity");
              quantityField.textContent = `${quantity} ${
                quantity === 1 ? "unidade" : "unidades"
              }`;

              amountField.classList.add("order-item-total");
              amountField.textContent = formatValue(amount);
            } else {
              titleField.classList.add("order-item-title-cancelled");
              titleField.textContent = displayName;
              quantityField.classList.add("order-item-quantity-cancelled");
              quantityField.textContent = `Cancelado`;
            }

            infoField.appendChild(skuIdField);
            infoField.appendChild(wrapper);
            infoField.appendChild(quantityField);
            infoField.append(amountField);

            itemField.appendChild(imageContainerField);
            itemField.appendChild(infoField);

            itemListField.appendChild(itemField);
          }
        } else {
          itemListField.textContent = "Não há itens para esse pedido.";
        }
      }

      if (payments) {
        for (const payment of payments) {
          const { paymentMethodId, amount } = payment;
          const paymentMethodField =
            document.querySelector("#payment-id-field");
          const paymentValueField = document.querySelector(
            "#payment-amount-field"
          );

          if (paymentMethodField) {
            paymentMethodField.textContent = paymentMethodId;
          }

          if (paymentValueField) {
            paymentValueField.textContent = `Total de ${formatValue(amount)}`;
          }
        }
      }

      //Summary
      {
        const orderCouponsList = document.querySelector("#order-coupons-list");
        const totalDiscountsField = document.querySelector(
          "#order-total-discounts"
        );
        const totalCouponsField = document.querySelector(
          "#order-total-coupons"
        );
        const summaryTotalItensElement = document.querySelector(
          "#summary-total-itens"
        );
        const totalItensField = document.querySelector("#order-total-itens");
        const totalShippingField = document.querySelector(
          "#order-shipping-total"
        );

        const orderTaxesList = document.querySelector("#order-taxes-list");

        const totalTaxesField = document.querySelector("#order-total-taxes");
        const orderIcmsField = document.querySelector("#order-icms-field");
        const orderIcmsStField = document.querySelector("#order-icmsst-field");
        const orderTotalTotal = document.querySelector("#order-total-total");

        if (financialSummary) {
          const { shippingValue, totalDiscount } = financialSummary;

          if (totalShippingField) {
            if (shippingValue == 0) {
              totalShippingField.textContent = "Grátis";
            } else {
              totalShippingField.textContent = formatValue(shippingValue);
            }
          }

          if (totalDiscountsField) {
            if (totalDiscount > 0) {
              totalDiscountsField.textContent =
                "-" + formatValue(totalDiscount);
            } else {
              totalDiscountsField.textContent = formatValue(totalDiscount);
            }
          }
        } else {
          totalDiscountsField.textContent = formatValue(0);
          totalCouponsField.textContent = formatValue(0);
          summaryTotalItensElement.textContent = formatValue(0);
          totalItensField.textContent = formatValue(0);
          totalShippingField.textContent = formatValue(0);
        }

        let couponTotal = 0;

        if (totalCouponsField) {
          if (couponTotal > 0) {
            totalCouponsField.textContent = "-" + formatValue(couponTotal);
          } else {
            totalCouponsField.textContent = formatValue(couponTotal);
          }
        }

        for (const coupon of coupons) {
          const { promotionName, discountValue } = coupon;
          const couponField = document.createElement("li");

          const couponNameField = document.createElement("span");
          const couponValueField = document.createElement("span");

          couponNameField.textContent = promotionName;

          couponValueField.classList.add("value");
          if (discountValue > 0) {
            couponTotal += discountValue;
            couponValueField.textContent = "-" + formatValue(discountValue);
          } else {
            couponValueField.textContent = formatValue(discountValue);
          }

          couponField.appendChild(couponNameField);
          couponField.appendChild(couponValueField);

          orderCouponsList.appendChild(couponField);
        }

        if (summaryTotalItensElement) {
          const { quantity, amount } =
            items && items.length > 0
              ? items.reduce((prev, curr) => ({
                  quantity: prev.quantity + curr.quantity,
                  amount: prev.amount + curr.amount,
                }))
              : {
                  quantity: 0,
                  amount: 0,
                };

          totalItensField &&
            (totalItensField.textContent = formatValue(amount));
          summaryTotalItensElement.textContent = quantity;
        }

        if (invoices && invoices.length > 0) {
          let icmsStValue = 0;
          let icmsValue = 0;

          invoices.map((invoice) => {
            icmsStValue += invoice.icmsStValue;

            invoice.items.map((item) => {
              icmsValue += item.icmsValue;
            });
          });

          totalTaxesField &&
            (totalTaxesField.textContent = formatValue(
              icmsStValue + icmsValue
            ));
          orderIcmsField &&
            (orderIcmsField.textContent = formatValue(icmsValue));
          orderIcmsStField &&
            (orderIcmsStField.textContent = formatValue(icmsStValue));
        } else {
          totalTaxesField && (totalTaxesField.textContent = formatValue(0));
          orderIcmsField && (orderIcmsField.textContent = formatValue(0));
          orderIcmsStField && (orderIcmsStField.textContent = formatValue(0));
        }

        orderTotalTotal &&
          (orderTotalTotal.textContent = formatValue(orderTotal));
      }
    } else {
      const itemListField = document.querySelector("#order-items-list");

      itemListField &&
        (itemListField.textContent = "Não foi possível carregar os itens");
    }

    if (mainInvoice) {
      const { issuer } = mainInvoice;

      //Issuer
      if (issuer) {
        const { name } = issuer;

        const issuerInfoBlock = document.querySelector("#issuer-info");
        const issuerNameField = document.querySelectorAll("#issuer-name");
        // const issuerEmailField = document.querySelectorAll("#issuer-email");

        issuerNameField.forEach((e) => (e.textContent = name));
        // issuerEmailField.forEach((e) => (e.textContent = email));

        issuerInfoBlock && issuerInfoBlock.classList.add("show");
      }
    }

    //Order id
    {
      const orderIdFields = document.querySelectorAll("#order-id-field");
      orderIdFields.forEach((f) => {
        f.textContent = orderId;
      });
    }

    //Customer
    if (customer) {
      const { document: companyDocument } = customer;

      const companyInfoBlock = document.querySelector("#company-info");
      const companyNameField = document.querySelector("#company-name");
      const companyDocumentField = document.querySelector("#company-document");

      // companyNameField.forEach(
      //   (e) => (e.textContent = `${firstName} ${lastName}`)
      // );

      if (companyDocumentField)
        companyDocumentField.textContent = companyDocument.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );

      companyInfoBlock && companyInfoBlock.classList.add("show");
    }

    //Shipping Adress
    if (shippingAddress) {
      const { address2, address3, city, county, country, postalCode, state } =
        shippingAddress;

      const shippingAddressField = document.querySelectorAll(
        "#shipping-address-field"
      );
      const shippingAddressBlock = document.querySelector(
        "#shipping-address-info"
      );

      const shippingAddressArray = [
        address2,
        address3,
        county,
        city && state ? `${city}/${state}` : null,
      ];

      if (postalCode) {
        const formattedShippingPostalCode = [
          String(postalCode).slice(0, 5),
          String(postalCode).slice(5),
        ].join("-");

        shippingAddress.push(formattedShippingPostalCode);
      }

      shippingAddressArray.push(country);

      const filteredShippingAddressArray = shippingAddressArray.filter(
        (value) => value !== undefined && value !== null && value.trim() !== ""
      );
      const shippingAddressString = filteredShippingAddressArray.join(", ");

      shippingAddressField.forEach(
        (e) => (e.textContent = shippingAddressString + ".")
      );

      shippingAddressBlock && shippingAddressBlock.classList.add("show");
    }

    //BillingAddress
    if (billingAddress) {
      const { address2, address3, city, county, country, postalCode, state } =
        billingAddress;

      const billingAddressField = document.querySelectorAll(
        "#billing-address-field"
      );
      const billingAddressBlock = document.querySelector(
        "#billing-address-info"
      );

      const billingAddressArray = [
        address2,
        address3,
        county,
        city && state ? `${city}/${state}` : null,
      ];

      if (postalCode) {
        const formattedBillingPostalCode = [
          String(postalCode).slice(0, 5),
          String(postalCode).slice(5),
        ].join("-");
        billingAddress.push(formattedBillingPostalCode);
      }

      billingAddressArray.push(country);

      const filteredBillingAddressArray = billingAddressArray.filter(
        (value) => value !== undefined && value !== null && value.trim() !== ""
      );
      const billingAddressString = filteredBillingAddressArray.join(", ");

      billingAddressField.forEach(
        (e) => (e.textContent = billingAddressString + ".")
      );

      billingAddressBlock && billingAddressBlock.classList.add("show");
    }

    if (ovNumber || poNumber) {
      const additionalInformationBlock =
        document.querySelector("#additional-info");

      if (ovNumber) {
        const commerceOrderField = document.getElementById(
          "num-commerce-order-field"
        );

        if (commerceOrderField) {
          commerceOrderField.textContent =
            `Ordem de venda: ${ovNumber}` || "ID não disponível";
        } else {
          console.error(
            "❌ Elemento com ID 'num-commerce-order-field' não encontrado."
          );
        }
      }

      if (poNumber) {
        const commerceOrderField = document.getElementById("num-sell-field");

        if (commerceOrderField) {
          commerceOrderField.textContent =
            `Ordem de compra: ${poNumber}` || "ID não disponível";
        } else {
          console.error("❌ Elemento com ID 'num-sell-field' não encontrado.");
        }
      }
      additionalInformationBlock &&
        additionalInformationBlock.classList.add("show");
    }

    //Shipping Method
    {
      const shippingMethodElement = document.querySelector("#shipping-method");
    }

    //Invoices
    {
      const invoicesListField = document.querySelector("#invoices-list-field");

      if (invoicesListField) {
        if (invoices.length > 0) {
          let departureDate = null;
          let deliveryDate = null;
          const now = new Date();
          for (const invoice of invoices) {
            const currentDeparture = parseCustomDate(invoice.departureDate);
            const currentDelivery = parseCustomDate(invoice.deliveryDate);

            if (currentDeparture) {
              if (!departureDate || currentDeparture < departureDate) {
                departureDate = currentDeparture;
              }
            }

            if (currentDelivery) {
              if (!deliveryDate || currentDelivery > deliveryDate) {
                deliveryDate = currentDelivery;
              }
            }

            const invoiceField = document.createElement("li");
            const mainInfoField = document.createElement("div");
            const invoiceTrackingField = document.createElement("div");

            mainInfoField.classList.add("invoice-main-info");
            invoiceTrackingField.classList.add("invoice-tracking-main-info");

            const invoiceIdField = document.createElement("span");
            invoiceIdField.classList.add("bold");
            invoiceIdField.textContent = invoice.invoiceId;

            const date = new Date(invoice.issueDate);
            const dateField = document.createElement("span");
            const emittedInMessage = document.createElement("span");
            emittedInMessage.classList.add("mobile-message");
            emittedInMessage.textContent = "Emitido em: ";
            const formattedDate = new Intl.DateTimeFormat('pt-BR').format(new Date(date));
            const formattedDateField = document.createElement("span");
            formattedDateField.textContent = formattedDate;
            dateField.appendChild(emittedInMessage);
            dateField.appendChild(formattedDateField);

            const paymentTypeField = document.createElement("span");
            paymentTypeField.classList.add("payment-type");

            if (order && order.financialSummary) {
              if (order) {
                paymentTypeField.textContent =
                  order.financialSummary.paymentMethods[0].paymentMethodId;
              }
            }

            const totalValueField = document.createElement("span");
            totalValueField.classList.add("total-value");
            totalValueField.classList.add("bold");
            const formattedTotal = formatValue(invoice.value);
            totalValueField.textContent = formattedTotal;

            const linkElement = document.createElement("a");
            linkElement.textContent = "Baixar nota";

            const queryParams = new URLSearchParams(window.location.search);
            queryParams.append("trackOrder", invoice.internalNumber);

            const trackOrderElement = document.createElement("button");
            trackOrderElement.classList.add("delivery-track-outline");
            trackOrderElement.textContent = "Rastrear";
            trackOrderElement.addEventListener("click", () => {
              openTrackModal(orderId, invoice);
            });

            const buttonContainer = document.createElement("div");
            buttonContainer.classList.add("invoice-button-container");

            const trackOrderInvoice = document.createElement("button");
            trackOrderInvoice.classList.add("delivery-track");
            trackOrderInvoice.id = `invoice-pdf-${invoice.invoiceId}`;
            trackOrderInvoice.textContent = "Baixar";

            const errorMessage = document.createElement("span");
            errorMessage.classList.add("invoice-error-message");
            errorMessage.style.display = "none";
            errorMessage.style.color = "red";
            errorMessage.style.fontSize = "12px";
            errorMessage.style.paddingTop = "5px";
            errorMessage.textContent = "Não foram encontrados";

            trackOrderInvoice.addEventListener("click", () => {
              handleInvoiceClick(invoice.invoiceId, invoice.issuer.cnpj, trackOrderInvoice, errorMessage);
            });

            mainInfoField.appendChild(invoiceIdField);
            mainInfoField.appendChild(dateField);
            mainInfoField.appendChild(paymentTypeField);
            mainInfoField.appendChild(totalValueField);

            invoiceField.appendChild(mainInfoField);
            // invoiceField.appendChild(linkElement);
            buttonContainer.appendChild(trackOrderInvoice);
            buttonContainer.appendChild(errorMessage);
            invoiceTrackingField.appendChild(trackOrderElement);
            invoiceTrackingField.appendChild(buttonContainer);
            
            invoiceField.appendChild(invoiceTrackingField);

            invoicesListField.appendChild(invoiceField);
          }

          if (departureDate) {
            const departureDateField = document.querySelector("#step-heading-delivery");
            const departureDateFieldText = document.querySelector("#step-delivery-date-text");
            const closedField = document.querySelector("#step-heading-closed");
            const departureDateText = document.querySelector("#step-delivery-date");

            closedField.classList.add("active");

            if (departureDateField && departureDate <= now) {
              departureDateField.classList.add("active");
              departureDateFieldText.textContent = "Enviado";

            } else if (departureDate > now) {
              departureDateFieldText.textContent = "Previsão de envio";

            }
            departureDateText.textContent = new Intl.DateTimeFormat('pt-BR').format(new Date(departureDate));
          }
          
          if (deliveryDate) {
            const deliveryDateField = document.querySelector("#step-heading-completed");
            const deliveryDateFieldText = document.querySelector("#step-completed-date-text");
            const deliveryDateText = document.querySelector("#step-completed-date");

            if (deliveryDateField && deliveryDate <= now) {
              deliveryDateField.classList.add("active");
              deliveryDateFieldText.textContent = "Entregue";

            } else if (deliveryDate > now) {
              deliveryDateFieldText.textContent = "Previsão de entrega";
              
            }
            deliveryDateText.textContent = new Intl.DateTimeFormat('pt-BR').format(new Date(deliveryDate));
          }

        } else {
          invoicesListField.textContent = "Não há notas fiscais";
        }
      }
    }
  } else {
    const errorElement = document.querySelector(".error-message");
    errorElement && (errorElement.style.display = "block");
  }
}

function handleReturnButtonOrder() {
  const returnButton = document.querySelector("#return-button-order");

  if (!returnButton) {
    console.error("❌ #back-button-container não encontrado no DOM.");
    return;
  }

  returnButton.setAttribute("data-page", "/pages/pedidos");

  returnButton.addEventListener("click", async (event) => {
    getOrderData(page = 1);
    initOrdersPage(1);
    event.preventDefault();
    const pageUrl = "/pages/pedidos";
    const pageContent = document.getElementById("page-content");

    if (pageContent) {
      try {
        const response = await fetch(pageUrl);
        if (!response.ok) throw new Error("Erro ao carregar a página.");

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const content = doc.querySelector("#page-account");

        pageContent.innerHTML = content
          ? content.innerHTML
          : "<p>Conteúdo não encontrado.</p>";

        await loadOrderData();
      } catch (error) {
        console.error(error);
        pageContent.innerHTML = "<p>Erro ao carregar o conteúdo.</p>";
      }
    }
  });
}

async function loadOrderData() {
  try {
    showMyAccountSpinner(document.querySelector(".tab-orders"));

    if (typeof getOrderData !== "function") {
      console.error(
        "❌ Erro: getOrderData não está definido. Verifique a importação."
      );
      return;
    }

    const orders = await fetchWithCache(
      "orders",
      getOrderData
    );
    const orderData = orders.items;

    const orderBlocksContainer = await waitForElement("#tab-orders");
    if (orderBlocksContainer) {
      if (typeof renderOrdersData === "function") {
        renderOrdersData(orderData);
      } else {
        console.error(
          "❌ Erro: renderOrdersData não está definido. Verifique a importação."
        );
      }
    } else {
      console.error("❌ Erro: #tab-orders não encontrado.");
    }
  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
    renderOrdersData([]);
  } finally {
    removeMyAccountSpinner(document.querySelector("#tab-orders"));
  }
}

function loadOrderDetails(orderData) {
  renderOrderDetailData(orderData);
  handleReturnButtonOrder();
}

let arrowAvailable = true;

async function sortDirection() {
  if (arrowAvailable) {
    arrowAvailable = false;
    sortAscending = !sortAscending;
    const sortButton = document.querySelector(".sort-button");
    if (sortButton) {
      sortButton.classList.toggle("asc", sortAscending);
    }
    await searchOrders();
    setTimeout(() => {
      arrowAvailable = true;
    }, 1000);
  }
}

async function searchOrders() {
  const filterBy = document.getElementById('order-query-filter-by').value;
  const filterValue = document.getElementById("order-query-filter").value.toUpperCase();

  const sortDirection = sortAscending ? 'asc' : 'desc';
  await getOrderData(1, filterBy, filterValue, sortDirection);
}

async function handleInvoiceClick(nfNumber, issuerDocument, button, errorDisplay) {
  try {
    button.style.backgroundColor = "";
    errorDisplay.style.display = "none";

    const orderId = document.querySelector('#order-id-field').textContent;

    await downloadInvoice(orderId, nfNumber, issuerDocument);

  } catch (error) {
    console.error('[handleInvoiceClick] Erro:', error);

    button.style.backgroundColor = "#ff4d4d";
    button.style.color = "white";
    errorDisplay.style.display = "block";
    errorDisplay.textContent = "Nota não encontrada";
  }
}

async function downloadInvoice(commerceOrderId, invoiceNumber, issuerDocument) {
  try {
    const domain = baseMsUrl();
    const token = await login();

    const params = new URLSearchParams();
    params.append("customerId", customerId);
    params.append("invoiceNumber", invoiceNumber);
    params.append("issuerDocument", issuerDocument);
    params.append("filterBy", "orderIds");
    params.append("filter", commerceOrderId);

    params.append("limit", "1");
    params.append("offset", "0");

    const url = `${domain}/shopify-order-connector/v1/shopify-order-connector/invoice-orders?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Status ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    
    window.open(blobUrl, '_blank');

    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

  } catch (err) {
    console.error('[downloadInvoice] Erro capturado:', err);
    throw new Error(`Erro ao baixar nota fiscal: ${err}`);
  }
}